import { useLayoutEffect, useCallback } from 'react';

function useFitText(ref, { minFontSize = 10 } = {}) {
  const fitText = useCallback(() => {
    const element = ref.current;
    if (!element) return;

    const isOverflowing = () => element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;

    element.style.fontSize = ''; 

    let min = minFontSize;
    let max = parseFloat(window.getComputedStyle(element).fontSize) || 100; 
    let mid;

    while (min <= max) {
      mid = Math.floor((min + max) / 2);
      element.style.fontSize = `${mid}px`;

      if (isOverflowing()) {
        max = mid - 1;
      } else {
        min = mid + 1;
      }
    }

    element.style.fontSize = `${max}px`;

  }, [ref, minFontSize]);

  useLayoutEffect(() => {
    fitText();
    window.addEventListener('resize', fitText);
    return () => window.removeEventListener('resize', fitText);
  }, [fitText]);
}

export default useFitText;